import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { downloadPoPuSampleTemplate } from "../helpers/poPuSampleTemplate";

const base_assets = process.env.REACT_APP_BASE_ASSETS_URL || "";

/**
 * Format picker before PO/PU sample download (Excel or CSV).
 * Open with: data-bs-toggle="modal" data-bs-target="#poPuSampleFormatModal"
 * or openPoPuSampleFormatModal() after setSampleType("PO"|"PU").
 */
const PoPuSampleFormatModal = ({ sampleType = "PO", onTypeNeeded }) => {
  const { t } = useTranslation();
  const [format, setFormat] = useState("xlsx");
  const [busy, setBusy] = useState(false);

  const resolveType = () => {
    if (typeof onTypeNeeded === "function") {
      return onTypeNeeded() || sampleType;
    }
    return sampleType;
  };

  const handleDownload = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await downloadPoPuSampleTemplate(resolveType(), format, t);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="modal fade common-modal"
      id="poPuSampleFormatModal"
      tabIndex={-1}
      aria-labelledby="poPuSampleFormatModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <img
              className="common-modal-exclamation-img"
              src={base_assets + "images/icons/exclamation-mark-green.png"}
              alt=""
            />
            <p className="modal-content-text mb-2" id="poPuSampleFormatModalLabel">
              {t("Export format")}
            </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
              <label className="d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name="poPuSampleFormat"
                  value="xlsx"
                  checked={format === "xlsx"}
                  onChange={() => setFormat("xlsx")}
                />
                {t("Excel (.xlsx)")}
              </label>
              <label className="d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name="poPuSampleFormat"
                  value="csv"
                  checked={format === "csv"}
                  onChange={() => setFormat("csv")}
                />
                {t("CSV")}
              </label>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn modal-content-yes"
              data-bs-dismiss="modal"
              disabled={busy}
              onClick={handleDownload}
            >
              {busy ? t("Please wait") : t("Download")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoPuSampleFormatModal;
